module.exports = __webpack_public_path__ + "static/media/image10.c169575a.png";